module.exports = __webpack_public_path__ + "img/WordPress.3de43f16.png";